import clsx from 'clsx'

import { useCurrencyOptions } from '@fv/client-core'
import type { PropsWithClassName, ShipmentLocation } from '@fv/client-types'
import type { Currency } from '@fv/models'

import { SelectField } from '@/components/inputs/SelectField'

type Value = Currency | null
type Props = PropsWithClassName<{
  value: Value
  onChange: (value: Value) => void
  locations?: ShipmentLocation[]
  size?: 'small'
}>

export const CurrencySelector = ({
  className,
  value,
  onChange,
  locations,
  size,
}: Props) => {
  const currencyOptions = useCurrencyOptions(locations)

  return (
    <SelectField
      className={clsx(className, size === 'small' && 'h-10 !py-0')}
      name="displayCurrency"
      value={value ?? ''}
      onChange={e => onChange((e.target.value || null) as Value)}
      options={[
        { text: 'As quoted', value: '' },
        ...currencyOptions.map(c => ({
          text: `Show in ${c.text}`,
          value: c.value,
        })),
      ]}
    />
  )
}
